// NOTE
// Please use your own firebase details below. For more details visit: https://pixinvent.com/demo/vuexy-vuejs-admin-dashboard-template/documentation/development/firebaseIntegration.html


import firebase from 'firebase/app'

// Initialize Firebase
var config = {
    apiKey: "AIzaSyDnQyMcPLqiQZgnOVGftNTpuUjeEqZkwrk",
    authDomain: "pryze-admin.firebaseapp.com",
    databaseURL: "https://pryze-admin-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "pryze-admin",
    storageBucket: "pryze-admin.appspot.com",
    messagingSenderId: "743073919054",
    appId: "1:743073919054:web:91494f2a98cf9ffa6b531f",
    measurementId: "G-K9HQVHQQ7T"
};

firebase.initializeApp(config);
